<template>
    <div class="quanyi">
        <div class="tit">
            <img src="https://appd.knowbox.cn/ss/activity/parent_frontend/member/vip_logo_02.png">
            <span>会员权益</span>
        </div>
        <div class="icons">
            <div class="icon" v-for="(item, index) in iconDate" :key="index">
                <img :src="item.img" alt="">
                <span class="text1">{{ item.text1 }}</span>
                <span class="text2">{{ item.text2 }}</span>
                <!-- <span v-if="item.text3" class="text3">{{ item.text3 }}</span> -->
            </div>
        </div>
        <div class="card">
            <div class="quanyi_card"></div>
        </div>
        <div class="button">
            <div class="btn1" @click="goQuestion">常见问题</div>
            <div v-if="source == 'ios' && version >= '5002' " class="btn2" @click="restoreProduct">恢复购买</div>
            <div class="btn3" @click="goPrivacy">隐私政策</div>
        </div>

    </div>
</template>

<script>
    import utils from "@/assets/js/utils";
    import { restoreProduct } from "@/utils/hybird";
    export default {
        data() {
            return {
                iconDate: [
                    {
                        img: 'https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_quanyi_1.png',
                        text1: '轻课音频',
                        text2: '海量畅学'
                    },
                    {
                        img: 'https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_quanyi_2.png',
                        text1: '同步练',
                        text2: '免费练'
                    },
                    {
                        img: 'https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_quanyi_3.png',
                        text1: '阅读绘本',
                        text2: '海量畅学',
                        text3: '(西游记暂不支持)',
                    },
                    {
                        img: 'https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_quanyi_more.png',
                        text1: '更多权益',
                        text2: '敬请期待'
                    }
                ],
                version: '',
            }
        },
        props: {
            source: {   // and；ios
                type: String
            }      
        },
        methods: {
            goQuestion() {
                let url = window.location.href.split('?')[0];
                let path = this.source === 'ios' ? url.split("member_ios").join('common_problems?hideTitleBar=false') : url.split("member_and").join('common_problems?hideTitleBar=true');
                console.log(path)
                url = encodeURIComponent(path)
                window.location.href = "hybird://method/openNewWindow?url=" + url;
            },
            goPrivacy() {
                let url = encodeURIComponent('https://ssweb.knowbox.cn/web4activity/feed_agreement/privacy.html?hideTitleBar=false');
                window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=小盒课堂用户隐私协议";
            },
            restoreProduct(){
                restoreProduct();
            }
        },
        created(){
            this.version = utils.getQueryString('version').split('.').join('');
        }
    }
</script>

<style lang="scss" scoped>
    .quanyi {
        background: #ffffff;
        margin-top: .2rem;
        .tit {
            font-size: .28rem;
            color: #161616;
            text-align: left;
            text-indent: .4rem;
            height: .8rem;
            line-height: .8rem;
            padding-top: .4rem;
            box-sizing: content-box;
            font-weight: bolder;
            img {
                width: .49rem;
                height: .36rem;
                margin-right: .08rem;
            }
        }
        .icons {
            display: flex;
            justify-content: space-between;
            padding: 0 .66rem;
            .icon {
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                // position: relative;
                img {
                    width: .84rem;
                }
                .text1 {
                    color: #919294;
                    font-size: .22rem;
                    line-height: .42rem;
                }
                .text2 {
                    color: #7b531e;
                    font-size: .28rem;
                }
                &:last-of-type {
                    .text2 {
                        color: #919294;
                    }
                }
                .text3 {
                    position: absolute;
                    color: #7b531e;
                    font-size: .22rem;
                    bottom: 0;
                }
            }
        }
        .card {
            margin: .42rem auto .2rem;
            padding-bottom: .46rem;
            .quanyi_card {
                width: 6.9rem;
                height: 8.5rem;
                margin: 0 auto;
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/quanyi_bg_new.png) center center no-repeat;
                background-size: 100%;
                span {
                    // display: block;
                    height: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // line-height: 1.03rem;
                    font-size: .28rem;
                    color: #7b531e;
                    font-family: PingFangSC-Medium;
                    // text-indent: 1rem;
                    padding-left: 1rem;
                    box-sizing: border-box;
                    i {
                        text-indent: 0;
                        color: #ff571d;
                        font-family: PingFangSC-Semibold;
                        font-weight: bold;
                    }
                }
            }

        }
        .button {
            border-top: .2rem solid #f6f6f8;
            padding: 0 .45rem 0 .4rem;
            box-sizing: border-box;
            text-align: left;
            font-family: PingFangSC-Medium;
	        font-size: .28rem;
	        color: #161616;
            line-height: 1.2rem;
            .btn2,.btn3 {
                border-top: 1px solid #f3f3f3;
            }
            .btn1,.btn2,.btn3 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &::after {
                    content: '';
                    display: inline-block;
                    width: .14rem;
                    height: .14rem;
                    border-top: 1px solid #919294;
                    border-right: 1px solid #919294;
                    transform: rotate(45deg);
                }
            }
        }
    }
</style>